import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';

import { boardCategoryList, programBoardList } from '@/network/apis/apiUri';
import useContent from '@/localization/data_export';

import FOUNDATION_URL from '../utils/constants';

export default function FoundationBoardTable() {
  const { mode } = useSelector((state) => state);

  const anchorTitle = useContent(['global', 'anchor', 'title']);
  const boardCustomType = useContent('boardCustomType');

  const boardId = boardCustomType ? boardCustomType.csv.find((item) => item.type === '2').id : '26';

  const [selectBoard, setSelectBoard] = useState(1);

  const handleItemClick = (e) => {
    const el = e.currentTarget;
    const link = el.dataset.href;

    if (link) window.open(link, '_blank');
  };

  const { isSuccess: cateSuccess, data: categoryList } = useQuery(
    ['main', 'foundation-board', 'category'],
    async () => {
      const cateRes = await boardCategoryList({ board_id: boardId, lan_code: mode });

      return cateRes.data.items.map((item) => ({
        id: item.category_data_id,
        text: item.text,
      }));
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      retry: false,
      enabled: !!boardId && !!mode,
    }
  );

  const { isSuccess: boardSuccess, data: boardList } = useQuery(
    ['main', 'foundation-board', selectBoard],
    async () => {
      const response = await programBoardList({
        board_id: boardId,
        category_data_id: selectBoard,
        lan_code: mode,
        page_info: {
          row_count: 6,
          number: 0,
        },
      });

      return response.data.item
        .sort((a, b) => +b.is_top - a.is_top)
        .map((item) => ({
          id: item.board_item_id,
          link: FOUNDATION_URL.get(selectBoard).concat('/', item.board_item_id),
          title: item.title,
          date: item.reg_date.slice(0, 10),
          hit: item.hit_count,
          isTop: item.is_top,
        }));
    },
    {
      staleTime: 1000 * 60 * 3,
      retry: false,
      enabled: !!boardId && !!mode && cateSuccess,
    }
  );

  return (
    <div className="foundation-board-table">
      <div className="category-list">
        {cateSuccess &&
          categoryList.map((cate) => (
            <button
              type="button"
              key={cate.id}
              onClick={() => setSelectBoard(cate.id)}
              data-active={cate.id === selectBoard}
            >
              {cate.text}
            </button>
          ))}
      </div>
      <table>
        <caption className="sr-only">
          {mode === 'ko'
            ? '이 표에는 번호, 제목, 날짜, 공지사항, 채용 공고, 입찰 정보 및 언론의 보기가 제공됩니다. 재단 사이트에 게시판을 공개합니다.'
            : 'this table provides a no, titles, dates, and views of notices, job postings, bidding information, and press release bulletin boards on the foundation site.'}
        </caption>
        <colgroup>
          <col width="10%" />
          <col width="60%" />
          <col width="20%" />
          <col width="10%" />
        </colgroup>
        <thead>
          <tr>
            <th className="sr-only">index</th>
            <th className="sr-only">title</th>
            <th className="sr-only">date</th>
            <th className="sr-only">hit count</th>
          </tr>
        </thead>
        <tbody>
          {boardSuccess &&
            boardList.map((item, index) => (
              <tr key={item.id} title={anchorTitle} data-href={item.link} onClick={handleItemClick}>
                <td>{index + 1}</td>
                <td data-is-top={item.isTop}>{item.title}</td>
                <td className="time-fs-fixed">{item.date}</td>
                <td>{item.hit}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}
